import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class TotalLiving extends Page{
    constructor(){
        super({
            id : 'total_living',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}